


import axios from 'axios'


export default class APIConnector{

    getCourseTopicDataById(topicId, callback) {
        axios({
            method: 'post',
            url: 'https://nafes.app/revision/revision-php/ws/course/CourseTopicWS.php?method=getCourseTopicDataById&topicId='+topicId,


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }
}